class BackLinkStorageService {
  static name = 'backLinkStorage';

  static getOrCreate () {
    try {
      let serializedState = sessionStorage.getItem(this.name)
      if (!serializedState) {
        serializedState = JSON.stringify({})
        sessionStorage.setItem(this.name, serializedState)
      }
      return JSON.parse(serializedState)
    } catch (error) {
      return undefined
    }
  }

  static addOrUpdateField (field, value) {
    const filterStorage = this.getOrCreate()
    filterStorage[field] = value
    const serializedState = JSON.stringify(filterStorage)
    sessionStorage.setItem(this.name, serializedState)
  }

  static addOrUpdateFields (object) {
    const filterStorage = this.getOrCreate()
    Object.keys(object).forEach(key => {
      filterStorage[key] = object[key]
    })
    const serializedState = JSON.stringify(filterStorage)
    sessionStorage.setItem(this.name, serializedState)
  }

  static updateAllFields (object) {
    const filterStorage = {}
    Object.keys(object).forEach(key => {
      filterStorage[key] = object[key]
    })
    const serializedState = JSON.stringify(filterStorage)
    sessionStorage.setItem(this.name, serializedState)
  }

  static deleteField (field) {
    const filterStorage = this.getOrCreate()
    delete filterStorage[field]
    const serializedState = JSON.stringify(filterStorage)
    sessionStorage.setItem(this.name, serializedState)
  }

  static clear () {
    sessionStorage.removeItem(this.name)
  }
}

export { BackLinkStorageService }
